import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { useLazySentinels } from "../hooks";

import { EmptyList, Loading, Button, Header } from "../../../components";
import { parseSearchParams } from "../../../helpers/clean-object";

export const Sentinels: React.FC = () => {
  const navigate = useNavigate();
  const limit = 25;
  const [search, { data, error, loading, fetchMore }] = useLazySentinels();
  console.log("data", data);
  console.log("error", error);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    search({
      fetchPolicy: "network-only",
      variables: {
        limit,
        offset: 0,
        where: parseSearchParams(searchParams),
      },
    });
  }, [searchParams]);

  const renderList = () => {
    if (loading) return <Loading />;
    if (data?.sentinels?.results?.length === 0) {
      return <EmptyList text="Aucun vps" />;
    }

    return (
      <table className="table-auto w-full">
        <thead>
          <tr className="text-xs text-gray-500 text-left">
            <th className="padding-table font-medium text-left">Nom</th>
            <th className="padding-table font-medium text-center">Ip</th>
          </tr>
        </thead>
        <tbody>
          {data?.sentinels?.results?.map((sentinel, index) => (
            <tr
              onClick={() => navigate(`/sentinel/${sentinel.id}`)}
              key={`sentinel-${sentinel.id}`}
              className={`text-xs cursor-pointer ${
                index % 2 ? "" : "bg-gray-50"
              } `}
            >
              <td className="padding-table text-left">
                {sentinel?.name ?? "-"}
              </td>
              <td className="padding-table text-center">{sentinel.ip}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <Header title="Sentinelle" subtitle="Liste des sentinelles" />

      <div className="main-container">
        <button
          className="btn mb-2"
          onClick={() => navigate("/sentinel/create")}
        >
          Nouvelle Sentinelle
        </button>
        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {renderList()}
        </div>
        {data?.sentinels?.hasMore && (
          <Button
            disabled={loading}
            loading={loading}
            onClick={() => {
              fetchMore({
                variables: {
                  offset: data?.sentinels?.results?.length,
                  limit,
                  where: parseSearchParams(searchParams),
                },
              });
            }}
          >
            Plus
          </Button>
        )}
      </div>
    </>
  );
};
